import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CitiesRepository } from '@/core/domain/cities/repositories/cities.repository';
import { GetCitiesUseCase } from '@/core/domain/cities/usecases/getCities.usecase';
import { CitiesImplRepository } from './cities-impl.repository';

const GetCitiesUseCaseFactory = (citiesRepository: CitiesRepository) =>
    new GetCitiesUseCase(citiesRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetCitiesUseCase,
            useFactory: GetCitiesUseCaseFactory,
            deps: [CitiesRepository],
        },
        {
            provide: CitiesRepository,
            useClass: CitiesImplRepository,
        },
    ],
})
export class CitiesDataModule {}
